module.exports = __webpack_public_path__ + "img/parlement-en.612b338a.png";